export const PortState = {
	BLOCKED: 0,
	FREE: 1,
	BUSY: 2,
};